const containers = document.querySelectorAll(".step_container");

Array.prototype.forEach.call(containers, (element) => {
    element.addEventListener('click', () => {
        // const container = getClosest(event.target, '.step_container');
        element.classList.toggle('step_container--active')
    });
});

const menubutton = document.querySelector(".menubutton");

menubutton.addEventListener('click', () => {
    const menu = document.getElementById('mobilemenu_navigation');
    if(menu.classList.contains('mobilemenu_navigation--active')) {
        menu.classList.remove('mobilemenu_navigation--active');
    } else {
        menu.classList.add('mobilemenu_navigation--active');
    }
});
